export default __webpack_public_path__ + "static/academy-099a46754e24298afeb5d71ee66a3133.png";